var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _g, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _g2, _path87, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubixCompute8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 839,
    viewBox: "0 0 588 839",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.121 665.57V707.44L295.651 749.31L295.221 707.44L223.121 665.57Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.121 665.57L250.961 649.94L323.481 691.81L295.221 707.44L223.121 665.57Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.544 704.535C247.979 703.187 248.06 698.675 245.725 694.457C243.39 690.238 239.522 687.912 237.087 689.26C234.652 690.608 234.571 695.121 236.906 699.339C239.241 703.557 243.109 705.883 245.544 704.535Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.505 715.211C265.94 713.863 266.021 709.35 263.686 705.132C261.351 700.914 257.483 698.588 255.048 699.936C252.613 701.284 252.532 705.796 254.867 710.015C257.202 714.233 261.07 716.559 263.505 715.211Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M281.628 725.68C284.063 724.332 284.144 719.819 281.809 715.601C279.474 711.383 275.606 709.056 273.171 710.405C270.736 711.753 270.655 716.265 272.99 720.483C275.325 724.701 279.193 727.028 281.628 725.68Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M475.32 399.5L403.32 442.5L384.82 545L399.82 768.5L431.32 821.5L466.32 810.5L479.82 757V665L487.82 545L475.32 399.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M295.33 707.439V749.309L367.85 791.179L367.42 749.309L295.33 707.439Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M295.33 707.44L323.16 691.81L395.68 733.69L367.42 749.31L295.33 707.44Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M317.739 746.415C320.174 745.067 320.255 740.555 317.92 736.336C315.585 732.118 311.718 729.792 309.282 731.14C306.847 732.488 306.766 737.001 309.101 741.219C311.437 745.437 315.304 747.763 317.739 746.415Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M335.704 757.09C338.139 755.742 338.22 751.229 335.885 747.011C333.55 742.793 329.682 740.467 327.247 741.815C324.812 743.163 324.731 747.675 327.066 751.893C329.402 756.112 333.269 758.438 335.704 757.09Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M353.841 767.555C356.276 766.207 356.357 761.694 354.022 757.476C351.686 753.258 347.819 750.931 345.384 752.28C342.949 753.628 342.868 758.14 345.203 762.358C347.538 766.576 351.406 768.903 353.841 767.555Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.309 222.74L422.209 381L367.599 412.53L93.6992 254.27L148.309 222.74Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.591 96.9297L148.311 222.74L435.261 388.53L435.211 262.4L148.591 96.9297Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.971 259.62L152.801 232L164.611 239.13L116.781 266.75",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.23 270.35L170.06 242.73L181.87 249.86L134.04 277.47",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M140.182 280.45L188.012 252.84L199.822 259.96L151.992 287.58",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.391 291.18L206.231 263.56L218.041 270.69L170.201 298.31",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.031 300.99L224.861 273.38L236.671 280.51L188.841 308.12",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M194.291 311.72L242.121 284.11L253.931 291.24L206.101 318.85",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M212.24 321.83L260.07 294.21L271.89 301.34L224.05 328.96",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M230.461 332.56L278.291 304.94L290.101 312.07L242.271 339.69",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M250.051 343.38L297.891 315.76L309.701 322.89L261.861 350.51",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M267.311 354.11L315.141 326.49L326.951 333.62L279.121 361.24",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M285.271 364.21L333.102 336.6L344.911 343.73L297.081 371.34",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M303.48 374.94L351.31 347.33L363.12 354.46L315.29 382.07",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M322.121 384.76L369.951 357.14L381.761 364.27L333.931 391.89",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M339.371 395.49L387.211 367.87L399.021 375L351.181 402.61",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M444.53 729.03L444.32 724.85L442.84 704.05C438.31 616.38 438.16 531.5 442.68 443.85",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M444.53 729.03L444.32 724.85L442.84 704.05C438.31 616.38 438.16 531.5 442.68 443.85",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M448.64 356.66L450.68 333.82L367.6 286.4L367.49 411.02L93.5198 252.83V126.69L12.7698 80.0801L7.9298 154.12C1.4398 253.41 0.769801 352.99 5.9198 452.36L12.7698 584.62L93.5198 631.24V505.1L367.5 663.28V789.42L449.72 836.89L448.95 817.03",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M448.64 356.66L450.68 333.82L367.6 286.4L367.49 411.02L93.5198 252.83V126.69L12.7698 80.0801L7.9298 154.12C1.4398 253.41 0.769801 352.99 5.9198 452.36L12.7698 584.62L93.5198 631.24V505.1L367.5 663.28V789.42L449.72 836.89L448.95 817.03",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M366.55 727.41L147.27 601.02V538.03L366.55 664.63V727.41Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8789 81.59L149.129 2L586.069 254.27L449.819 333.86L367.599 286.39L422.339 254.93L148.589 96.93L93.6189 128.21L12.8789 81.59Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M448.951 815.79L449.711 835.65L586.071 757.58V253.04L449.821 332.63L448.721 356.88",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M448.951 815.79L449.711 835.65L586.071 757.58V253.04L449.821 332.63L448.721 356.88",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M442.911 443.4L441.401 477.02C438.931 531.36 438.401 584.4 440.381 638.76L444.321 722.15",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M442.911 443.4L441.401 477.02C438.931 531.36 438.401 584.4 440.381 638.76L444.321 722.15",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M447.67 792.86L447.91 797.96",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M446.449 767.08L446.799 774.59",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M445.289 742.67L445.609 749.31",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M444.641 420.52L444.371 426.49",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M445.7 397.16L445.43 403.18",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M447.071 374L446.801 379.9",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M120.971 17.87L558.421 270.43L559.061 772.89L586.071 757.1V254.27L149.131 2L120.971 17.87Z",
    fill: "#D7DCE0",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M25.94 237.61L23.73 273.5C21.19 314.72 21.02 356.05 23.24 397.29L25.95 447.77L422.35 678.42L420.26 641.59C417.43 591.65 417.61 541.58 420.82 491.66L422.35 467.83L25.94 237.61Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M148.59 49.7798V96.9298L230.27 144.09L229.79 96.9298L148.59 49.7798Z",
    fill: "#FC6833",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M148.59 49.7799L179.94 32.1699L261.61 79.3299L229.79 96.9299L148.59 49.7799Z",
    fill: "#FC6833",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M261.609 79.3301V126.49L230.269 144.09L229.789 96.9301L261.609 79.3301Z",
    fill: "#FC6833",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M173.863 93.6529C176.607 92.1335 176.698 87.0475 174.066 82.293C171.434 77.5386 167.075 74.916 164.331 76.4354C161.586 77.9548 161.495 83.0408 164.127 87.7953C166.76 92.5498 171.118 95.1723 173.863 93.6529Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M194.095 105.67C196.84 104.151 196.931 99.0651 194.298 94.3106C191.666 89.5561 187.307 86.9336 184.563 88.453C181.819 89.9724 181.728 95.0584 184.36 99.8129C186.992 104.567 191.351 107.19 194.095 105.67Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M214.519 117.464C217.263 115.945 217.354 110.859 214.722 106.105C212.09 101.35 207.731 98.7275 204.987 100.247C202.242 101.766 202.151 106.852 204.784 111.607C207.416 116.361 211.774 118.984 214.519 117.464Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M211.129 78.4701L229.119 68.0801L247.119 78.4701L229.119 88.8601L211.129 78.4701Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M186.35 64.7401L204.35 54.3501L222.34 64.7401L204.35 75.1301L186.35 64.7401Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M163.09 50.64L181.08 40.25L199.07 50.64L181.08 61.03L163.09 50.64Z",
    fill: "#BC411B",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M148.311 601.18L93.7011 632.72L93.6211 506.62L148.311 538.19V601.18Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M511.129 552.89V629.35L544.239 648.47V572.01L511.129 552.89Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M544.238 572.01V648.47L567.928 634.79V558.33L544.238 572.01Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M549.93 577.22V590.42C549.93 591.27 550.85 591.8 551.59 591.38L563.02 584.78C563.36 584.58 563.57 584.22 563.57 583.82V570.62C563.57 569.77 562.65 569.24 561.91 569.66L550.48 576.26C550.14 576.46 549.93 576.82 549.93 577.22Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M549.93 600.96V614.16C549.93 615.01 550.85 615.54 551.59 615.12L563.02 608.52C563.36 608.32 563.57 607.96 563.57 607.56V594.36C563.57 593.51 562.65 592.98 561.91 593.4L550.48 600C550.14 600.2 549.93 600.56 549.93 600.96Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M549.93 622.97V636.17C549.93 637.02 550.85 637.55 551.59 637.13L563.02 630.53C563.36 630.33 563.57 629.97 563.57 629.57V616.37C563.57 615.52 562.65 614.99 561.91 615.41L550.48 622.01C550.14 622.21 549.93 622.57 549.93 622.97Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M516.248 567.31L539.118 580.52",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M516.248 576.81L539.118 590.02",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M516.248 587.88L539.118 601.09",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M516.248 597.38L539.118 610.59",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M516.248 607.89L539.118 621.1",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M516.248 617.39L539.118 630.6",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M511.129 477.02V553.48L544.239 572.6V496.14L511.129 477.02Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.129 477.02L534.819 463.34L567.929 482.46L544.239 496.14L511.129 477.02Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.238 496.14V572.6L567.928 558.92V482.46L544.238 496.14Z",
    fill: "#6E9965",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.93 501.35V514.55C549.93 515.4 550.85 515.93 551.59 515.51L563.02 508.91C563.36 508.71 563.57 508.35 563.57 507.95V494.75C563.57 493.9 562.65 493.37 561.91 493.79L550.48 500.39C550.14 500.59 549.93 500.95 549.93 501.35Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.93 525.09V538.29C549.93 539.14 550.85 539.67 551.59 539.25L563.02 532.65C563.36 532.45 563.57 532.09 563.57 531.69V518.49C563.57 517.64 562.65 517.11 561.91 517.53L550.48 524.13C550.14 524.33 549.93 524.69 549.93 525.09Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.93 547.11V560.31C549.93 561.16 550.85 561.69 551.59 561.27L563.02 554.67C563.36 554.47 563.57 554.11 563.57 553.71V540.51C563.57 539.66 562.65 539.13 561.91 539.55L550.48 546.15C550.14 546.35 549.93 546.71 549.93 547.11Z",
    fill: "#43663A",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.248 491.44L539.118 504.65",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.248 500.95L539.118 514.15",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.248 512.01L539.118 525.22",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.248 521.51L539.118 534.72",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.248 532.02L539.118 545.23",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.248 541.52L539.118 554.73",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M350.779 187.29L381.759 169.4L412.739 187.13L381.759 205.17L350.779 187.29Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M399.85 215.12L430.83 197.24L461.81 214.96L430.83 233.01L399.85 215.12Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M448.21 358.47L504.84 327.46V340.85L447.24 373.24L426.85 361.88C424.74 360.71 423.42 358.5 423.38 356.08C423.3 350.86 428.92 347.53 433.46 350.1L448.2 358.46L448.21 358.47Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M446.65 382.18L504.84 351.46V364.85L445.73 396.52L426.57 385.43C424.56 384.27 423.31 382.13 423.27 379.81C423.19 374.61 428.86 371.37 433.31 374.06L446.66 382.17L446.65 382.18Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M445.17 404.86L504.85 374.52V387.91L444.23 419.8L426.32 408.39C424.46 407.21 423.32 405.17 423.29 402.96C423.21 397.74 428.96 394.53 433.37 397.33L445.19 404.86H445.17Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M444.27 428.38L504.85 397.33V410.72L442.96 442.39L426.23 431.67C424.42 430.51 423.31 428.52 423.28 426.37C423.2 421.2 428.97 418.07 433.26 420.96L444.27 428.37V428.38Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M448.129 799.7L508.709 768.65V782.04L448.389 814.72L430.089 802.99C428.279 801.83 427.169 799.84 427.139 797.69C427.059 792.52 432.829 789.39 437.119 792.28L448.129 799.69V799.7Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M446.969 775.92L507.549 744.87V758.26L447.229 790.94L428.929 779.21C427.119 778.05 426.009 776.06 425.979 773.91C425.899 768.74 431.669 765.61 435.959 768.5L446.969 775.91V775.92Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M445.68 750.68L506.26 719.63V733.02L445.94 765.7L427.64 753.97C425.83 752.81 424.72 750.82 424.69 748.67C424.61 743.5 430.38 740.37 434.67 743.26L445.68 750.67V750.68Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M444.43 726.37L505.01 695.32V708.71L444.69 741.39L426.39 729.66C424.58 728.5 423.47 726.51 423.44 724.36C423.36 719.19 429.13 716.06 433.42 718.95L444.43 726.36V726.37Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7197 109.4L28.9797 119.54C30.8697 120.59 32.0497 122.56 32.0797 124.71C32.1497 129.37 27.1197 132.34 23.0497 130.04L9.67969 122.48",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36031 132.121L27.6203 142.261C29.5103 143.311 30.6903 145.281 30.7203 147.431C30.7903 152.091 25.7603 155.061 21.6903 152.761L8.32031 145.201",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08102 154.34L26.341 164.48C28.231 165.53 29.411 167.5 29.441 169.65C29.511 174.31 24.481 177.28 20.411 174.98L7.04102 167.42",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70016 176.57L24.9602 186.71C26.8502 187.76 28.0302 189.73 28.0602 191.88C28.1302 196.54 23.1002 199.51 19.0302 197.21L5.66016 189.65",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89062 482.46L26.1506 492.6C28.0406 493.65 29.2206 495.62 29.2506 497.77C29.3206 502.43 24.2906 505.4 20.2206 503.1L8.21063 496.31",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99023 505.61L27.2502 515.75C29.1402 516.8 30.3202 518.77 30.3502 520.92C30.4202 525.58 25.3902 528.55 21.3202 526.25L9.74023 519.7",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85156 528.29L28.1116 538.43C30.0016 539.48 31.1816 541.45 31.2116 543.6C31.2816 548.26 26.2516 551.23 22.1816 548.93L10.6016 542.38",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4707 551.36L29.0407 561.11C30.9307 562.16 32.1107 564.13 32.1407 566.28C32.2107 570.94 27.1807 573.91 23.1107 571.61L11.7907 565.21",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_936_4418",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 409,
    width: 91,
    height: 78
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3203 434.23L41.3903 409.63L131.18 461.48L131.11 486.07L41.3203 434.23Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_936_4418)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_936_4418",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 409,
    width: 91,
    height: 78
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3903 409.63L131.18 461.48L131.11 486.07L41.3203 434.23L41.3903 409.63Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_936_4418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.0806 435.52L74.2306 434.45V439.03C74.2206 439.62 74.2306 440.19 74.2306 440.73C74.2406 441.28 74.2505 441.81 74.2705 442.32C74.2905 442.83 74.3105 443.31 74.3405 443.78C74.3605 444.24 74.4005 444.67 74.4305 445.09C74.4305 445.21 74.4505 445.33 74.4605 445.45L67.5106 430.57L65.8505 429.61L65.8105 443.53L67.6606 444.6L67.6805 438.8C67.6805 438.68 67.6805 438.54 67.6705 438.37C67.6705 438.22 67.6606 438 67.6506 437.75C67.6506 437.5 67.6205 437.17 67.6005 436.76C67.5805 436.36 67.5405 435.85 67.5005 435.26C67.4705 434.84 67.4406 434.34 67.4006 433.77L74.3605 448.45L76.0605 449.43L76.1005 435.5",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7509 441.71L78.9809 440.69L78.9609 447.14C78.9609 448.01 79.0809 448.82 79.3409 449.59C79.6009 450.37 79.9609 451.07 80.4409 451.69C80.9109 452.3 81.4609 452.8 82.1109 453.17C82.6309 453.47 83.1009 453.63 83.5509 453.66C84.0009 453.68 84.3809 453.6 84.7109 453.38C84.8609 453.29 84.9909 453.17 85.0909 453.03V454.69L86.8509 455.71L86.8809 445.26L85.1109 444.24L85.0909 450.53C85.0909 450.9 85.0309 451.22 84.9209 451.47C84.8009 451.72 84.6409 451.9 84.4509 452.01C84.2509 452.12 84.0109 452.16 83.7309 452.13C83.4609 452.1 83.1509 451.99 82.8209 451.8C82.3709 451.54 82.0009 451.2 81.6809 450.78C81.3709 450.36 81.1309 449.88 80.9709 449.34C80.8109 448.8 80.7209 448.23 80.7309 447.62L80.7509 441.72",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7798 458.02C93.2398 457.71 92.7698 457.28 92.3598 456.73C91.9498 456.18 91.6298 455.57 91.3898 454.89C91.1598 454.22 91.0398 453.52 91.0398 452.84C91.0398 452.16 91.1598 451.63 91.3998 451.23C91.6398 450.83 91.9698 450.6 92.3798 450.53C92.7898 450.46 93.2698 450.58 93.8098 450.89C94.3498 451.2 94.8199 451.63 95.2299 452.17C95.6399 452.72 95.9698 453.32 96.1998 453.99C96.4298 454.66 96.5499 455.32 96.5499 456.01C96.5499 456.7 96.4298 457.25 96.1898 457.64C95.9499 458.04 95.6298 458.28 95.2098 458.35C94.7998 458.43 94.3299 458.31 93.7999 458.01M91.1498 443.42L89.3798 442.4L89.3398 457.07L91.1098 458.09V456.76C91.3198 457.17 91.5699 457.57 91.8699 457.98C92.1899 458.41 92.5298 458.8 92.9198 459.17C93.3098 459.54 93.6898 459.84 94.0798 460.06C94.8698 460.51 95.5698 460.69 96.2098 460.58C96.8398 460.47 97.3398 460.11 97.6998 459.49C98.0698 458.88 98.2498 458.04 98.2498 457C98.2498 455.96 98.0698 454.91 97.7098 453.89C97.3498 452.87 96.8498 451.93 96.2198 451.11C95.5998 450.29 94.8698 449.64 94.0598 449.17C93.6898 448.96 93.3298 448.82 92.9698 448.76C92.6098 448.7 92.2899 448.69 91.9799 448.74C91.6799 448.8 91.4298 448.91 91.2398 449.09C91.1998 449.12 91.1698 449.16 91.1398 449.19L91.1599 443.43",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.461 457.75C101.511 457.48 101.591 457.25 101.691 457.06C101.911 456.66 102.241 456.45 102.661 456.42C103.081 456.39 103.611 456.55 104.221 456.91C104.621 457.14 104.971 457.45 105.301 457.84C105.631 458.23 105.911 458.66 106.121 459.13C106.341 459.6 106.461 460.07 106.491 460.52V460.66L101.451 457.75M104.231 455.02C103.571 454.64 102.951 454.41 102.381 454.36C101.811 454.31 101.321 454.41 100.921 454.68C100.511 454.94 100.191 455.35 99.9613 455.89C99.7313 456.43 99.6113 457.12 99.6113 457.94C99.6113 458.97 99.8113 460.01 100.211 461.03C100.621 462.07 101.181 463.01 101.891 463.88C102.601 464.75 103.421 465.45 104.351 465.99C104.781 466.24 105.211 466.41 105.651 466.53C106.101 466.66 106.511 466.7 106.911 466.69C107.311 466.69 107.641 466.6 107.911 466.44L107.031 464.47C106.581 464.66 106.171 464.74 105.781 464.69C105.391 464.63 104.971 464.48 104.531 464.23C103.901 463.87 103.341 463.4 102.861 462.83C102.381 462.26 102.011 461.63 101.751 460.94C101.551 460.42 101.431 459.89 101.391 459.34L108.281 463.32L108.301 462.46C108.311 461.73 108.221 461 108.021 460.27C107.821 459.54 107.541 458.84 107.171 458.18C106.801 457.51 106.361 456.9 105.861 456.36C105.361 455.81 104.811 455.37 104.231 455.03",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.091 462.69L115.321 461.67L115.291 472.12L117.061 473.14L117.091 462.69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.2 457.28C115.83 457.07 115.54 457.02 115.33 457.13C115.12 457.25 115.01 457.5 115.01 457.88C115.01 458.29 115.12 458.67 115.32 459.01C115.52 459.35 115.82 459.63 116.19 459.85C116.56 460.07 116.84 460.11 117.05 459.99C117.26 459.88 117.37 459.62 117.37 459.24C117.37 458.83 117.27 458.45 117.06 458.11C116.86 457.76 116.56 457.48 116.19 457.27",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.251 475.97C124.671 475.63 124.131 475.2 123.641 474.67C123.161 474.13 122.741 473.54 122.371 472.88C122.011 472.23 121.741 471.52 121.541 470.79C121.351 470.06 121.261 469.34 121.261 468.59C121.261 467.84 121.361 467.22 121.551 466.72C121.751 466.22 122.031 465.84 122.381 465.6C122.751 465.36 123.171 465.25 123.651 465.28C124.141 465.31 124.681 465.5 125.261 465.83C125.841 466.16 126.381 466.6 126.861 467.13C127.351 467.67 127.761 468.26 128.121 468.92C128.471 469.58 128.751 470.28 128.951 471.01C129.151 471.74 129.251 472.47 129.241 473.2C129.231 473.93 129.131 474.55 128.931 475.05C128.731 475.55 128.451 475.93 128.101 476.18C127.741 476.43 127.321 476.54 126.831 476.51C126.341 476.48 125.811 476.29 125.231 475.96M125.291 463.74C124.441 463.25 123.661 462.98 122.951 462.92C122.231 462.87 121.611 463 121.081 463.34C120.551 463.68 120.131 464.2 119.841 464.9C119.541 465.6 119.391 466.47 119.391 467.5C119.391 468.53 119.531 469.57 119.821 470.62C120.111 471.66 120.521 472.65 121.051 473.6C121.581 474.55 122.201 475.41 122.921 476.18C123.631 476.95 124.411 477.58 125.261 478.07C126.111 478.56 126.891 478.83 127.601 478.88C128.321 478.93 128.941 478.79 129.471 478.44C130.011 478.1 130.421 477.58 130.721 476.88C131.021 476.18 131.161 475.31 131.161 474.29C131.161 473.27 131.031 472.24 130.731 471.21C130.441 470.17 130.031 469.17 129.501 468.21C128.971 467.25 128.351 466.39 127.631 465.62C126.921 464.85 126.141 464.22 125.291 463.74Z",
    fill: "#459AA4"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_936_4418",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 269,
    y: 535,
    width: 139,
    height: 119
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M269.66 573.45L269.76 535.95L407.59 615.52L407.48 653.02L269.66 573.45Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_936_4418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.62 561.76V557.2L281.77 558.43C282.51 558.86 283.06 559.37 283.42 559.99C283.78 560.59 283.96 561.25 283.96 561.95C283.96 562.65 283.77 563.1 283.4 563.31C283.03 563.51 282.49 563.41 281.76 562.99L279.62 561.76ZM281.77 556.62L277.69 554.26L277.65 567.84L279.59 568.96L279.61 563.52L281.08 564.37L283.78 571.38L286.1 572.72L283.19 565.4C284.12 565.67 284.81 565.58 285.26 565.12C285.71 564.65 285.93 563.97 285.94 563.09C285.94 562.33 285.79 561.56 285.48 560.77C285.17 559.98 284.7 559.22 284.07 558.49C283.45 557.77 282.67 557.14 281.77 556.62Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.92 568.18L294.99 567.06L294.97 573.06C294.97 574.02 294.75 574.64 294.33 574.91C293.9 575.18 293.33 575.1 292.6 574.69C291.87 574.28 291.3 573.68 290.88 572.93C290.46 572.17 290.25 571.31 290.25 570.35L290.27 564.35L288.35 563.24L288.33 569.57C288.33 570.55 288.49 571.48 288.83 572.36C289.16 573.24 289.62 574.03 290.2 574.72C290.79 575.41 291.44 575.97 292.18 576.39C292.74 576.71 293.26 576.89 293.75 576.92C294.24 576.95 294.65 576.83 294.95 576.57V577.84L296.88 578.96L296.91 568.19",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.219 581.42C303.729 581.14 303.279 580.74 302.839 580.19C302.409 579.65 302.059 579.02 301.789 578.32C301.519 577.61 301.399 576.89 301.399 576.15C301.399 575.41 301.529 574.84 301.799 574.44C302.069 574.04 302.419 573.84 302.859 573.8C303.299 573.76 303.759 573.89 304.249 574.17C304.739 574.45 305.219 574.87 305.649 575.4C306.079 575.93 306.429 576.54 306.699 577.24C306.969 577.94 307.099 578.65 307.099 579.39C307.099 580.13 306.959 580.71 306.689 581.12C306.419 581.52 306.069 581.75 305.629 581.79C305.189 581.83 304.729 581.71 304.219 581.42ZM301.419 567.08L299.479 565.96L299.439 580.42L301.379 581.54V579.98C301.709 580.67 302.149 581.35 302.719 582C303.279 582.65 303.919 583.18 304.649 583.6C305.469 584.07 306.209 584.26 306.889 584.18C307.569 584.09 308.099 583.73 308.489 583.1C308.879 582.47 309.079 581.62 309.079 580.53C309.079 579.44 308.889 578.38 308.509 577.31C308.129 576.25 307.599 575.3 306.939 574.46C306.269 573.62 305.519 572.96 304.689 572.48C303.989 572.07 303.349 571.87 302.769 571.87C302.199 571.87 301.749 572.04 301.419 572.38L301.439 567.08",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.94 577.43L311 576.31L310.97 587.08L312.91 588.2L312.94 577.43ZM312 572.6C311.65 572.4 311.35 572.37 311.12 572.5C310.89 572.63 310.76 572.9 310.76 573.31C310.76 573.72 310.88 574.13 311.11 574.54C311.34 574.95 311.64 575.26 311.99 575.46C312.34 575.66 312.62 575.69 312.86 575.55C313.1 575.41 313.22 575.14 313.22 574.74C313.22 574.34 313.1 573.93 312.87 573.52C312.64 573.11 312.35 572.81 312 572.61",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.53 582.97L320.51 581.8L318.59 584.35L316.57 579.53L314.38 578.26L317.39 585.48L314.35 589.03L316.38 590.2L318.29 587.65L320.3 592.47L322.5 593.74L319.49 586.54L322.53 582.97Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.8 586.48C332.7 585.85 331.69 585.55 330.76 585.62C329.83 585.68 329.1 586.08 328.56 586.82C328.02 587.57 327.74 588.6 327.74 589.92C327.74 591.24 328.01 592.6 328.54 593.97C329.07 595.34 329.8 596.58 330.72 597.7C331.64 598.82 332.65 599.7 333.76 600.35C335.02 601.08 336.14 601.37 337.12 601.23C338.1 601.09 338.82 600.5 339.26 599.45L336.93 598.1C336.63 598.64 336.2 598.93 335.65 598.97C335.1 599.01 334.47 598.82 333.76 598.41C332.98 597.96 332.28 597.35 331.67 596.58C331.06 595.82 330.58 594.96 330.24 594C329.9 593.05 329.73 592.07 329.73 591.06C329.73 590.05 329.91 589.28 330.25 588.72C330.6 588.16 331.08 587.86 331.69 587.81C332.3 587.76 333.01 587.96 333.79 588.41C334.51 588.82 335.13 589.36 335.68 590.03C336.22 590.7 336.65 591.48 336.95 592.36L339.28 593.71C338.84 592.16 338.14 590.74 337.16 589.46C336.18 588.18 335.06 587.18 333.8 586.46",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.58 605.3C344.8 604.85 344.15 604.16 343.64 603.23C343.12 602.3 342.87 601.26 342.88 600.1C342.88 599.32 343.01 598.73 343.26 598.33C343.51 597.94 343.85 597.72 344.27 597.69C344.7 597.67 345.16 597.79 345.66 598.08C346.16 598.37 346.62 598.78 347.06 599.3C347.49 599.82 347.83 600.43 348.09 601.12C348.35 601.81 348.48 602.55 348.47 603.33C348.47 604.11 348.33 604.7 348.06 605.08C347.79 605.48 347.43 605.68 347 605.7C346.57 605.72 346.09 605.59 345.59 605.3M345.69 596.17C344.79 595.65 343.98 595.41 343.26 595.45C342.53 595.49 341.95 595.81 341.54 596.42C341.12 597.02 340.9 597.87 340.9 598.97C340.9 600.07 341.1 601.16 341.5 602.24C341.91 603.31 342.47 604.29 343.18 605.16C343.89 606.03 344.69 606.73 345.57 607.24C346.45 607.75 347.29 608 348.03 607.96C348.77 607.92 349.36 607.61 349.8 607.02C350.23 606.42 350.45 605.57 350.45 604.48C350.45 603.39 350.25 602.29 349.83 601.2C349.42 600.11 348.84 599.13 348.12 598.25C347.4 597.38 346.59 596.68 345.7 596.17",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.739 606.58C363.039 606.18 362.399 606 361.799 606.04C361.199 606.07 360.759 606.34 360.469 606.83C360.149 605.95 359.699 605.17 359.109 604.46C358.519 603.75 357.849 603.18 357.109 602.75C356.549 602.43 356.029 602.25 355.539 602.22C355.049 602.19 354.639 602.3 354.329 602.56V601.33L352.389 600.21L352.359 610.98L354.299 612.1L354.319 606.08C354.319 605.12 354.539 604.5 354.959 604.23C355.379 603.96 355.959 604.03 356.689 604.45C357.419 604.87 357.989 605.46 358.409 606.21C358.829 606.96 359.029 607.83 359.029 608.79L359.009 614.81L360.929 615.92L360.949 609.9C360.949 608.94 361.169 608.32 361.589 608.05C362.019 607.78 362.589 607.86 363.319 608.28C364.049 608.7 364.619 609.28 365.039 610.04C365.449 610.79 365.659 611.66 365.659 612.62L365.639 618.64L367.559 619.75L367.579 613.4C367.579 612.42 367.419 611.49 367.089 610.61C366.749 609.72 366.299 608.94 365.719 608.25C365.129 607.56 364.479 607 363.739 606.58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.81 622.18C374.32 621.9 373.86 621.49 373.43 620.95C372.99 620.4 372.64 619.78 372.38 619.08C372.11 618.37 371.98 617.64 371.98 616.9C371.98 616.16 372.12 615.59 372.39 615.2C372.65 614.8 373.01 614.59 373.45 614.56C373.89 614.52 374.35 614.65 374.84 614.93C375.33 615.21 375.8 615.63 376.24 616.16C376.67 616.69 377.02 617.3 377.29 618C377.56 618.7 377.68 619.41 377.68 620.15C377.68 620.89 377.55 621.47 377.28 621.88C377.01 622.28 376.66 622.51 376.22 622.55C375.78 622.59 375.31 622.47 374.81 622.18ZM375.27 613.24C374.55 612.83 373.91 612.62 373.35 612.64C372.78 612.66 372.33 612.82 372 613.12V611.54L370.06 610.42L370.01 626.31L371.95 627.43L371.97 620.75C372.32 621.44 372.77 622.12 373.33 622.78C373.88 623.43 374.52 623.97 375.24 624.38C376.05 624.85 376.8 625.04 377.48 624.96C378.15 624.87 378.68 624.51 379.08 623.88C379.47 623.25 379.66 622.39 379.66 621.31C379.66 620.23 379.47 619.16 379.09 618.11C378.7 617.05 378.17 616.1 377.51 615.25C376.83 614.4 376.09 613.73 375.28 613.26",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.07 621.96L388.14 620.84L388.12 626.84C388.12 627.8 387.9 628.42 387.48 628.69C387.06 628.96 386.48 628.88 385.75 628.47C385.02 628.06 384.45 627.46 384.03 626.71C383.61 625.95 383.4 625.09 383.4 624.13L383.42 618.13L381.5 617.02L381.48 623.35C381.48 624.33 381.64 625.26 381.98 626.14C382.31 627.02 382.77 627.81 383.35 628.5C383.94 629.19 384.59 629.75 385.33 630.17C385.89 630.49 386.41 630.67 386.9 630.7C387.39 630.73 387.8 630.61 388.1 630.35V631.62L390.03 632.74L390.06 621.97",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.9 622.07L392.95 620.94V623.62L391.84 622.98V624.8L392.94 625.44L392.92 631.4C392.92 632.46 393.14 633.35 393.61 634.09C394.07 634.83 394.74 635.45 395.61 635.95L397.14 636.83V634.97L395.96 634.28C395.56 634.05 395.28 633.8 395.12 633.53C394.95 633.26 394.87 632.92 394.87 632.51L394.89 626.55L397.17 627.87V626.05L394.9 624.73V622.05",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.319 632.3C400.409 631.52 400.689 631.02 401.169 630.81C401.639 630.59 402.219 630.68 402.889 631.07C403.619 631.49 404.239 632.1 404.739 632.88C405.239 633.67 405.489 634.47 405.499 635.3L400.319 632.31M402.979 629.24C402.059 628.71 401.249 628.47 400.539 628.51C399.829 628.56 399.279 628.89 398.889 629.5C398.489 630.12 398.299 630.98 398.289 632.09C398.279 633.2 398.479 634.28 398.879 635.36C399.279 636.43 399.829 637.4 400.539 638.27C401.249 639.14 402.049 639.84 402.939 640.36C404.039 640.99 404.959 641.21 405.709 641.01C406.449 640.81 406.969 640.29 407.259 639.46L405.169 638.25C404.739 639.01 403.999 639.08 402.959 638.48C402.229 638.06 401.629 637.45 401.119 636.64C400.619 635.83 400.349 634.98 400.299 634.08L407.459 638.21C407.509 637.91 407.529 637.56 407.529 637.16C407.529 636.12 407.339 635.08 406.959 634.06C406.579 633.04 406.039 632.11 405.349 631.26C404.659 630.41 403.879 629.74 402.989 629.23",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.54 536.97C270.56 536.4 269.76 536.85 269.76 537.98L269.67 571.4C269.67 572.52 270.46 573.9 271.44 574.46C272.42 575.02 273.22 574.57 273.22 573.45L273.31 540.03C273.31 538.9 272.52 537.53 271.54 536.97Z",
    fill: "#459AA4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubixCompute8);
export default __webpack_public_path__ + "static/media/RubixCompute8.31dbc09c8e7d77e5caa2cd80cd84d34f.svg";
export { ForwardRef as ReactComponent };